/* ==========================================================================
   Pro Natura - universele "In winkelwagen"-knop (gedrag)

   Eén gedelegeerde handler voor elke knop met [data-pn-atc]. De knop levert
   het variant-id aan via data-variant-id; het aantal is optioneel
   (data-quantity, standaard 1).

   Attributen
   ----------
   data-pn-atc            markeert de knop als winkelwagenknop
   data-variant-id        variant die toegevoegd wordt
   data-quantity          aantal (standaard 1)
   data-reload            "true" -> pagina verversen na toevoegen (winkelwagenpagina)

   Na een geslaagde toevoeging vuurt 'cart:item-added' zodat de mini-cart
   opent en zichzelf ververst.
   ========================================================================== */
(function () {
  'use strict';

  var LABEL_DEFAULT = 'In winkelwagen';
  var LABEL_BUSY    = 'Toevoegen\u2026';
  var LABEL_DONE    = '\u2713 Toegevoegd';
  var LABEL_ERROR   = 'Probeer opnieuw';
  var RESET_DELAY   = 2000;

  function labelEl(btn) {
    return btn.querySelector('.pn-atc__label');
  }

  function setLabel(btn, text) {
    var el = labelEl(btn);
    if (el) el.textContent = text;
  }

  function restLabel(btn) {
    return btn.getAttribute('data-label') || LABEL_DEFAULT;
  }

  window.pnAddToCart = function (btn) {
    if (!btn || btn.disabled) return;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var quantity = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    var reload   = btn.getAttribute('data-reload') === 'true';

    btn.disabled = true;
    setLabel(btn, LABEL_BUSY);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add mislukt');
        return response.json();
      })
      .then(function () {
        setLabel(btn, LABEL_DONE);

        if (reload) {
          window.location.reload();
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:item-added'));

        setTimeout(function () {
          btn.disabled = false;
          setLabel(btn, restLabel(btn));
        }, RESET_DELAY);
      })
      .catch(function () {
        btn.disabled = false;
        setLabel(btn, LABEL_ERROR);
        setTimeout(function () { setLabel(btn, restLabel(btn)); }, RESET_DELAY);
      });
  };

  /* Terugknop: de browser toont de pagina uit zijn eigen cache (bfcache) en daarmee
     ook de knop zoals die vlak na het toevoegen stond: uitgeschakeld en met het
     label "Toegevoegd". De knop wordt hier teruggezet in de ruststand, zodat de
     bezoeker het product opnieuw kan toevoegen. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var buttons = document.querySelectorAll('[data-pn-atc]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = false;
      setLabel(buttons[i], restLabel(buttons[i]));
    }
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pn-atc]');
    if (!btn) return;
    event.preventDefault();
    window.pnAddToCart(btn);
  });
})();
